var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-567 569.8 63.2 63.2",
    style: {
      enableBackground: "new -567 569.8 63.2 63.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0-config-icon{fill:#666666;}\n\t.st1-config-icon{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.609115917899544, 31.586322484351708) scale(-1, 1) translate(-31.609115917899544, -31.586322484351708)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    className: "st0-config-icon",
    d: "M575.9,601.4c0,12.5,10.2,22.7,22.6,22.7s22.6-10.2,22.6-22.7s-10.2-22.6-22.6-22.6 S575.9,589,575.9,601.4l22.6,20.4c11.2,0,20.4-9.2,20.4-20.4s-9.1-20.4-20.4-20.4s-20.4,9.1-20.4,20.4s9.1,20.4,20.4,20.4 L575.9,601.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path-2",
    className: "st0-config-icon",
    d: "M598.5,571.4c16.5,0,30,13.5,30,30s-13.5,30-30,30s-30-13.5-30-30S582,571.4,598.5,571.4v59.2 c16,0,29.2-13,29.2-29.2c0-16-13.2-29.2-29.2-29.2c-16,0-29.2,13.2-29.2,29.2s13,29.2,29.2,29.2V571.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.609115917899572, 31.5863224843517) rotate(150.00005363462506) translate(-31.609115917899572, -31.5863224843517)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path-3",
    className: "st1-config-icon",
    d: "M-151.4-745.4c0-12.8-10.3-23.1-23.1-23.1v3c10.9,0,19.9,9,19.9,19.9c0,11-9,20-19.9,20 s-19.9-9-19.9-20c0-1.8,0.1-3.8,0.7-5.5l-3.1-0.9c-0.6,2.2-0.9,4.3-0.9,6.6c0,12.8,10.3,23.1,23.1,23.1S-151.4-732.6-151.4-745.4 z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1-config-icon",
    d: "M587.5,604.3l-2.4,1.4c-0.3,0.2-0.4,0.5-0.3,0.8c0.6,2,1.7,3.9,3.1,5.4c0.2,0.2,0.6,0.3,0.8,0.1l2.4-1.4 c1,0.9,2.2,1.6,3.5,2v2.8c0,0.3,0.2,0.6,0.5,0.7c2,0.4,4.1,0.5,6.3,0c0.3-0.1,0.5-0.3,0.5-0.7v-2.8c1.3-0.5,2.5-1.1,3.5-2l2.4,1.4 c0.3,0.2,0.6,0.1,0.8-0.1c1.4-1.5,2.5-3.4,3.1-5.4c0.1-0.3,0-0.6-0.3-0.8l-2.4-1.4c0.2-1.3,0.2-2.7,0-4l2.4-1.4 c0.3-0.2,0.4-0.5,0.3-0.8c-0.6-2-1.7-3.9-3.1-5.4c-0.2-0.2-0.6-0.3-0.8-0.1l-2.4,1.4c-1-0.9-2.2-1.6-3.5-2v-2.8 c0-0.3-0.2-0.6-0.5-0.7c-2-0.4-4.1-0.5-6.3,0c-0.3,0.1-0.5,0.3-0.5,0.7v2.8c-1.3,0.5-2.5,1.1-3.5,2l-2.4-1.4 c-0.3-0.2-0.6-0.1-0.8,0.1c-1.4,1.5-2.5,3.4-3.1,5.4c-0.1,0.3,0,0.6,0.3,0.8l2.4,1.4C587.2,601.6,587.2,602.9,587.5,604.3 L587.5,604.3z M593.7,602.2c0-2.5,2.1-4.6,4.6-4.6c2.5,0,4.6,2.1,4.6,4.6c0,2.5-2.1,4.6-4.6,4.6 C595.8,606.8,593.7,604.8,593.7,602.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfig);
export default __webpack_public_path__ + "static/media/config.1db3fd523a937c1683692ee329f4216b.svg";
export { ForwardRef as ReactComponent };